import { makeStyles } from "@material-ui/core/styles";
import * as util from '../../../utils/Util';

export const useStyles = (value, type) =>
    makeStyles(theme => ({
        root: {
            "& .Mui-error": {
                color: acquireValidationColor(value, type, "")
            },
            "& .MuiFormHelperText-root": {
                color: acquireValidationColor(value, type, "helperText")
            },
            "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                'border-color': acquireBorderHoverColor(value, type)
            },
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                'border-color': acquireValidationColor(value, type, "outline")
            },
            "& .MuiInputLabel-outlined": {
                color: acquireValidationColor(value, type, "label")
            },
        }
    }));

const spaceTrimmed = (value, type) => value.prevValue && !isDate(type) && (util.trimSpaces(value.value) !== util.trimSpaces(value.prevValue) || value.value.value !== value.prevValue.value);
const date = (value, type) => value.prevValue && isDate(type) && value.value && value.value.getTime() !== new Date(value.prevValue).getTime();
const modify = (value) => value.modify && !value.prevValue && value.value;
const autocomplete = (value) => value.prevValue && value.value && value.prevValue.label !== value.value.label;
const modified = (value, type) => (type !== "autocomplete" && (spaceTrimmed(value, type) || date(value, type) || modify(value)))
    || (type === "autocomplete" && autocomplete(value));

const acquireValidationColor = (value, type, target) => {
    if (value.errors && value.errors.has(value.name)) {
        return "red";
    } else if (modified(value, type)) {
        return "orange";
    } else {
        if ("label" === target) {
            return "rgba(0, 0, 0, 0.54)";
        }
        return "rgba(0, 0, 0, 0.23)";
    }
};


const acquireBorderHoverColor = (value, type) => {
    if (value.errors && value.errors.has(value.name)) {
        return "red";
    } else if (modified(value, type)) {
        return "rgba(255, 129, 0, 1)";
    } else {
        return "black";
    }
};

const isDate = (type) => {
    return type === "date" || type === "yearMonth";
}